function ParamPartsControll () {

  setupWebViewEnhancements()
}

function setupWebViewEnhancements() {
  const ApptoWebPath = location.pathname
  const isWebView = ApptoWebPath.includes("/app/apptoweb/")
  // WebViewコンテキストでなければ、何もせずに終了
  if (!isWebView) {
    removeWebviewElements()
    return;
  }

  console.log('WebViewコンテキストを検出。不要要素の削除とリンクの動的監視を開始します。');

  // --- 初期処理 ---
  // 1. 不要な要素を削除
  removeUnnecessaryElements();

}


function removeUnnecessaryElements() {
  const elementsToRemove = document.querySelectorAll('[data-controll="atow"]');
  const elementsToShow = document.querySelectorAll('[data-controll="atow-show"]');
  if (elementsToRemove.length > 0) {
    elementsToRemove.forEach(element => {
      element.remove();
    });
    console.log(`WebView: ${elementsToRemove.length}個の不要な要素を削除しました。`);
  }
  if (elementsToShow.length > 0) {
    elementsToShow.forEach(element => {
      element.style.display = "block";
    });
    console.log(`WebView: ${elementsToShow.length}個の要素を表示。`);
  }
}

function removeWebviewElements() {
  const elementsToRemove = document.querySelectorAll('[data-controll="atow-show"]');
  if (elementsToRemove.length > 0) {
    elementsToRemove.forEach(element => {
      element.remove();
    });
    console.log(`WebView: ${elementsToRemove.length}個の不要な要素を削除しました。`);
  }
}



export {ParamPartsControll,removeUnnecessaryElements,removeWebviewElements}
